// @flow
import React from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import IconArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';

import '../ui/title.css';

type Props = {
    author: ?string,
    list: Array<?Object>,
    onChange: Function,
};

type State = {
    author: ?string,
    searchText: ?string,
    authorList: Array<?{
        id: string,
        name: string,
    }>
}

export default class AuthorList extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            author: '',
            searchText: '',
            authorList: [],
        };
    }

    componentWillMount() {
        this.setState(this.stateForProps(this.props));
    }

    stateForProps = (props: Props): Object => {
        const newState = {
            author: '',
            authorList: [],
        };
        if (props.list.length) {
            newState.authorList = this.props.list.map((item: ?Object) => {
                if (item && item.node) {
                    if (this.props.author === item.node.id) {
                        newState.author = `${item.node.firstName} ${item.node.lastName}`;
                    }
                    return {
                        id: item.node.id,
                        name: `${item.node.firstName} ${item.node.lastName}`,
                    };
                }
                return {};
            });
        }

        return newState;
    };

    handleUpdateInput = (searchText: ?string):void => {
        this.setState({
            searchText,
            author: searchText,
        });
    };

    handleNewRequest = (e: ?string, i: number):void => {
        this.setState({
            searchText: '',
        });
        if (this.state.authorList.length && this.state.authorList.length > i) {
            this.props.onChange(this.state.authorList[i]);
        }
    };

    render() {
        return (
            <div>
                <small className="small-title">Автор</small>
                <AutoComplete
                    hintText={this.state.author}
                    hintStyle={{
                        bottom: 11,
                        color: '#000',
                        whiteSpace: 'nowrap',
                        width: '90%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                    floatingLabelText={this.state.author ? '' : ' '}
                    searchText={this.state.searchText}
                    onUpdateInput={this.handleUpdateInput}
                    onNewRequest={this.handleNewRequest}
                    menuStyle={{ maxHeight: '30vh' }}
                    menuCloseDelay={50}
                    filter={AutoComplete.caseInsensitiveFilter}
                    dataSourceConfig={{ text: 'name', value: 'id' }}
                    dataSource={this.state.authorList}
                    openOnFocus={true}
                    menuProps={{
                        desktop: true,
                        disableAutoFocus: true,
                    }}
                />
                <IconArrow color="#777" className="header-filter--dropdown-arrow" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/author/AuthorList.js